











import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import ContentFeedCover from "@/components/ContentFeedCover";
import FormatMoney from "@/components/FormatMoney";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationFollowings",
  components: { NotificationItemView, ContentFeedCover, FormatMoney },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
});
